import { Box, Checkbox, Input, Text } from "@showitinc/showit-wc";
import React from "react";
import HelpConstants from "../../../constants/HelpConstants";
import styles from "./SiteSettingsModal.module.css";
import HelpTooltip from "../../../components/HelpTooltip";
import { initFormatter } from "../../../utils/PropertyFormatters";

const GoogleAnalytics = ({ siteSettings, onChange }) => {
  const { onChange: _onChange } = initFormatter((propInfo) => {
    const trimmedPropInfo = { ...propInfo, value: propInfo.value.trim() };
    onChange(trimmedPropInfo);
  });
  return (
    <Box mb="3">
      <Box p="3">
        <Text variant="heading-1" className={styles.codeTitle} variantStyle="med">
          Google Analytics
        </Text>
      </Box>
      <Box px="3" pb="3">
        <Text variant="small" variantStyle="light">
          In October 2020, Google released version 4 of Analytics. The new Measurement ID number
          (starting with G-) is now the standard which replaces the legacy Tracking ID (starting
          with UA-). If you enter a Measurement ID, you do not need to enter a Tracking ID.&nbsp;
          <a href={HelpConstants.GOOGLE_ANALYTICS} target="_blank" rel="noreferrer">
            Learn More
          </a>
        </Text>
      </Box>
      <Box mb="2">
        <Input
          className={styles["text-field"]}
          bordered
          type="text"
          propName="config.googleAnalyticsMeasurementId"
          label="Measurement ID"
          value={siteSettings.getIn(["config", "googleAnalyticsMeasurementId"], "")}
          onSIInput={_onChange("config.googleAnalyticsMeasurementId")}
          onSIChange={_onChange("config.googleAnalyticsMeasurementId")}
          placeholder="G-XXXXXXXXXX"
          longLabel
        />
      </Box>
      <Box d="flex" mb="2">
        <Checkbox
          className={styles.checkbox}
          checked={siteSettings.getIn(["config", "googleAnalyticsSkipWP"], false)}
          label="Do not include on blog templates"
          onSIChange={(e) =>
            onChange({ name: "config.googleAnalyticsSkipWP", value: e.target.checked })
          }
        />
        <span style={{ marginBottom: 12 }}>
          <HelpTooltip tooltipKey="google-analytics-skip-wp" />
        </span>
      </Box>
    </Box>
  );
};

export default GoogleAnalytics;
